/* Sesame collection: size and oil filters, sort, size buttons on cards, price per litre, add to cart (theme cart drawer), drift and reveal. */
(function () {
  'use strict';
  var KEY = '__ncol_nsc';
  if (window[KEY]) return;
  window[KEY] = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }

  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || 'Rs. {{amount}}';
    function delim(number, precision, thousands, decimal) {
      number = (number / 100).toFixed(precision == null ? 2 : precision);
      var parts = number.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousands || ',')) + (parts[1] ? (decimal || '.') + parts[1] : '');
    }
    var m = fmt.match(placeholder), v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = delim(cents, 0); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      default: v = delim(cents, 2);
    }
    return fmt.replace(placeholder, v);
  }
  // litres in a title such as "1 Litre ( Glass Bottle )", "5 Litre Tin", "500ml" or "... 5L"
  function litresIn(title) {
    var m = String(title).match(/(\d+(?:\.\d+)?)\s*(ml|millilitre|milliliter|litre|liter|ltr|lt|l)\b/i);
    if (!m) return null;
    var n = parseFloat(m[1]);
    return /^m/i.test(m[2]) ? n / 1000 : n;
  }
  function sizeLabel(l) { return l < 1 ? Math.round(l * 1000) + ' ml' : (l === 1 ? '1 litre' : l + ' litres'); }

  /* ---------- add to cart, using the theme's cart drawer when there is one ---------- */
  function toast(root, text, isError) {
    var t = root.querySelector('[data-toast]');
    if (!t) return;
    t.textContent = text; t.classList.toggle('is-error', !!isError); t.hidden = false;
    clearTimeout(t.__t); t.__t = setTimeout(function () { t.hidden = true; }, 2600);
  }
  function addToCart(root, form, btn) {
    var cart = document.querySelector('cart-drawer');
    var fd = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    var label = btn.querySelector('[data-label]');
    btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
    if (label) label.textContent = root.getAttribute('data-adding');
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(base.replace(/\.js$/, '') + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(root, res.description || res.message || 'Could not add to cart.', true); return false; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nsc-collection', cartData: res });
        if (cart && cart.dataset.cartType === 'drawer' && typeof cart.renderContents === 'function' && res.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(res, !document.body.classList.contains('page-overlay-cart-on'));
        } else if (cart && cart.dataset.cartType && cart.dataset.cartType !== 'drawer') {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        } else {
          toast(root, (res.product_title || '') + ' · ' + root.getAttribute('data-added'), false);
        }
        return true;
      })
      .catch(function () { toast(root, 'Could not add to cart. Check your connection and try again.', true); return false; })
      .then(function (ok) {
        btn.removeAttribute('aria-busy'); btn.disabled = false;
        if (ok) {
          btn.classList.add('is-added');
          if (label) label.textContent = root.getAttribute('data-added');
          setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = root.getAttribute('data-add'); }, 2200);
        } else if (label) label.textContent = root.getAttribute('data-add');
      });
  }

  /* ---------- one product card ---------- */
  function initCard(root, item, money) {
    var json = item.querySelector('[data-variants]');
    var variants = [];
    try { variants = JSON.parse(json ? json.textContent : '[]'); } catch (e) { variants = []; }
    variants.forEach(function (v) { v.litres = litresIn(v.title); });
    if (!variants.length) return;
    // a single-size product titled "... 500 ml" with a variant called "Default Title"
    if (variants.length === 1 && variants[0].litres == null) variants[0].litres = litresIn(item.querySelector('.nsc-card__title').textContent);
    item.__variants = variants;
    item.setAttribute('data-sizes', variants.map(function (v) { return v.litres; }).filter(function (l) { return l != null; }).join(' '));

    var idInput = item.querySelector('[data-id]');
    var btn = item.querySelector('[data-add-btn]');
    var label = btn && btn.querySelector('[data-label]');
    var now = item.querySelector('[data-now]'), was = item.querySelector('[data-was]'), per = item.querySelector('[data-per]');
    var save = item.querySelector('[data-save]'), savePct = item.querySelector('[data-save-pct]'), out = item.querySelector('[data-out]');
    var img = item.querySelector('.nsc-card__main');
    var links = item.querySelectorAll('[data-link]');
    var pills = Array.prototype.slice.call(item.querySelectorAll('[data-variant]'));
    var perWord = root.getAttribute('data-per') || 'a litre';

    function show(v, initial) {
      if (idInput) idInput.value = v.id;
      if (now) now.textContent = formatMoney(v.price, money);
      var hasCmp = v.compare > v.price;
      if (was) { was.hidden = !hasCmp; was.textContent = hasCmp ? formatMoney(v.compare, money) : ''; }
      if (save) { save.hidden = !hasCmp; if (savePct && hasCmp) savePct.textContent = Math.floor((v.compare - v.price) * 100 / v.compare); }
      if (out) out.hidden = !!v.available;
      if (per) per.textContent = v.litres && v.litres !== 1 ? formatMoney(Math.round(v.price / v.litres / 100) * 100, money).replace(/[.,]00(?!\d)/, '') + ' ' + perWord : '';
      if (btn) {
        btn.disabled = !v.available;
        if (label && !btn.hasAttribute('aria-busy')) label.textContent = v.available ? root.getAttribute('data-add') : root.getAttribute('data-soldout');
      }
      if (img && v.image && !initial) { img.removeAttribute('srcset'); img.src = v.image; }
      Array.prototype.forEach.call(links, function (a) { if (v.url) a.setAttribute('href', v.url); });
      pills.forEach(function (p) { p.setAttribute('aria-checked', String(+p.getAttribute('data-variant') === v.id)); p.tabIndex = +p.getAttribute('data-variant') === v.id ? 0 : -1; });
      item.__current = v;
    }
    var currentId = idInput ? +idInput.value : variants[0].id;
    var start = variants.filter(function (v) { return v.id === currentId; })[0] || variants[0];
    item.__select = function (litres) {
      if (litres == null) return;
      if (item.__current && item.__current.litres === litres) return;
      var pick = variants.filter(function (v) { return v.litres === litres && v.available; })[0] || variants.filter(function (v) { return v.litres === litres; })[0];
      if (pick) show(pick);
    };
    pills.forEach(function (p, i) {
      p.addEventListener('click', function () { var v = variants.filter(function (x) { return x.id === +p.getAttribute('data-variant'); })[0]; if (v) show(v); });
      p.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = pills[(i + d + pills.length) % pills.length]; n.focus(); n.click();
      });
    });
    show(start, true);
    var form = item.querySelector('[data-add-form]');
    if (form && btn) form.addEventListener('submit', function (e) { e.preventDefault(); if (!btn.disabled) addToCart(root, form, btn); });
  }

  /* ---------- filters ---------- */
  function initFilters(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-item]'));
    var sizeBox = root.querySelector('[data-size-chips]'), oilBox = root.querySelector('[data-oil-chips]');
    var count = root.querySelector('[data-count]'), word = root.querySelector('[data-count-word]');
    var empty = root.querySelector('[data-empty]');
    var state = { size: '', oil: '' };
    // size chips from the sizes on this page
    var sizes = {};
    items.forEach(function (it) { (it.getAttribute('data-sizes') || '').split(' ').forEach(function (l) { if (l) sizes[l] = true; }); });
    var list = Object.keys(sizes).map(parseFloat).sort(function (a, b) { return a - b; });
    if (sizeBox && list.length > 1) {
      list.forEach(function (l) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'nsc-chip'; b.setAttribute('aria-pressed', 'false'); b.setAttribute('data-size', String(l));
        b.textContent = sizeLabel(l);
        sizeBox.appendChild(b);
      });
      sizeBox.hidden = false;
    }
    // hide oil chips that have nothing on this page
    if (oilBox) each(oilBox, '[data-oil]', function (b) {
      var o = b.getAttribute('data-oil');
      if (o && !items.some(function (it) { return it.getAttribute('data-oil') === o; })) b.hidden = true;
    });
    function apply() {
      var shown = 0;
      items.forEach(function (it) {
        var okSize = !state.size || (' ' + it.getAttribute('data-sizes') + ' ').indexOf(' ' + state.size + ' ') > -1;
        var okOil = !state.oil || it.getAttribute('data-oil') === state.oil;
        it.hidden = !(okSize && okOil);
        if (!it.hidden) { shown++; if (state.size && it.__select) it.__select(parseFloat(state.size)); }
      });
      if (count) count.textContent = shown;
      if (word) word.textContent = shown === 1 ? word.getAttribute('data-one') : word.getAttribute('data-many');
      if (empty) empty.hidden = shown > 0;
    }
    function wire(box, key) {
      if (!box) return;
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        state[key] = b.getAttribute('data-' + key) || '';
        each(box, 'button', function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        apply();
      });
    }
    wire(sizeBox, 'size'); wire(oilBox, 'oil');
    var reset = root.querySelector('[data-reset]');
    if (reset) reset.addEventListener('click', function () {
      state.size = ''; state.oil = '';
      [sizeBox, oilBox].forEach(function (box) { if (box) each(box, 'button', function (x) { x.setAttribute('aria-pressed', String(!x.getAttribute('data-size') && !x.getAttribute('data-oil'))); }); });
      apply();
    });
    var sort = root.querySelector('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page');
      u.hash = root.querySelector('.nsc-grid') ? root.querySelector('.nsc-grid').id : '';
      window.location.href = u.toString();
    });
  }

  /* ---------- drift with the mouse, reveal on scroll ---------- */
  var depth = [], mx = 0, my = 0, tx = 0, ty = 0, raf = 0;
  function frame() {
    mx += (tx - mx) * .08; my += (ty - my) * .08;
    depth.forEach(function (el) { el.style.setProperty('--mx', mx.toFixed(3)); el.style.setProperty('--my', my.toFixed(3)); });
    raf = Math.abs(tx - mx) + Math.abs(ty - my) > .002 ? requestAnimationFrame(frame) : 0;
  }
  if (!reduce && fine) window.addEventListener('pointermove', function (e) {
    tx = e.clientX / window.innerWidth * 2 - 1; ty = e.clientY / window.innerHeight * 2 - 1;
    if (!raf && depth.length) raf = requestAnimationFrame(frame);
  }, { passive: true });
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .06 }) : null;

  function init(root) {
    if (root.__ncol) return;
    root.__ncol = true;
    root.classList.add('is-js');
    var money = root.getAttribute('data-money');
    each(root, '[data-item]', function (it) { initCard(root, it, money); });
    if (root.querySelector('[data-items]')) initFilters(root);
    each(root, '[data-reveal]', function (el) { if (reduce || !io) el.classList.add('is-in'); else io.observe(el); });
    if (!reduce) each(root, '[data-depth]', function (el) { depth.push(el); });
  }
  function initAll(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-nsc]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
